// Local seed data — used when Firestore is empty / not configured.
// Admin can later seed Firestore from these via the dashboard.
import { asset } from "@/lib/siteAssets";

export const PRODUCT_SEED = [
  {
    id: "p-chicken",
    slug: "chicken-pickle",
    name: "Chicken Pickle (Boneless)",
    name_te: "చికెన్ ఆవకాయ (బోన్‌లెస్)",
    description:
      "Spicy Andhra-style chicken pickle made with tender chicken pieces and traditional hand-ground spices.",
    description_te:
      "మృదువైన చికెన్ ముక్కలతో సాంప్రదాయ ఆంధ్ర సుగంధ ద్రవ్యాలతో తయారుచేసిన మసాలా చికెన్ ఆవకాయ.",
    image_url: asset("products/chicken.webp"),
    category: "non-veg",
    in_stock: true,
    featured: true,
    sizes: [
      { label: "250gm", price: 300 },
      { label: "500gm", price: 600 },
      { label: "1000gm", price: 1200 },
    ],
    sort: 1,
  },
  {
    id: "p-chicken-bone",
    slug: "chicken-pickle-bone",
    name: "Chicken Pickle (Bone-in)",
    name_te: "చికెన్ ఆవకాయ (ఎముకలతో)",
    description:
      "Spicy Andhra-style chicken pickle made with bone-in chicken pieces and traditional hand-ground spices.",
    description_te:
      "ఎముకలతో చికెన్ ముక్కలతో సాంప్రదాయ ఆంధ్ర సుగంధ ద్రవ్యాలతో తయారుచేసిన మసాలా చికెన్ ఆవకాయ.",
    image_url: null,
    category: "non-veg",
    in_stock: true,
    featured: false,
    sizes: [
      { label: "250gm", price: 250 },
      { label: "500gm", price: 500 },
      { label: "1000gm", price: 1000 },
    ],
    sort: 2,
  },
  {
    id: "p-mutton",
    slug: "mutton-pickle",
    name: "Mutton Pickle (Boneless)",
    name_te: "మటన్ ఆవకాయ (బోన్‌లెస్)",
    description:
      "Tender mutton pieces marinated in traditional Andhra spices and homemade seasoning.",
    description_te:
      "మృదువైన మటన్ ముక్కలను సాంప్రదాయ ఆంధ్ర సుగంధ ద్రవ్యాలలో మరిగించి తయారుచేయబడిన ఆవకాయ.",
    image_url: asset("products/mutton.webp"),
    category: "non-veg",
    in_stock: true,
    featured: true,
    sizes: [
      { label: "250gm", price: 550 },
      { label: "500gm", price: 1100 },
      { label: "1000gm", price: 2200 },
    ],
    sort: 3,
  },
  {
    id: "p-mutton-bone",
    slug: "mutton-pickle-bone",
    name: "Mutton Pickle (Bone-in)",
    name_te: "మటన్ ఆవకాయ (ఎముకలతో)",
    description:
      "Tender bone-in mutton pieces marinated in traditional Andhra spices and homemade seasoning.",
    description_te:
      "ఎముకలతో మృదువైన మటన్ ముక్కలను సాంప్రదాయ ఆంధ్ర సుగంధ ద్రవ్యాలలో మరిగించి తయారుచేయబడిన ఆవకాయ.",
    image_url: null,
    category: "non-veg",
    in_stock: true,
    featured: false,
    sizes: [
      { label: "250gm", price: 450 },
      { label: "500gm", price: 900 },
      { label: "1000gm", price: 1800 },
    ],
    sort: 4,
  },
  {
    id: "p-prawn",
    slug: "prawn-pickle",
    name: "Prawn Pickle (Medium)",
    name_te: "రొయ్యల ఆవకాయ",
    description:
      "Fresh prawn pickle blended with authentic Andhra spices and aromatic seasonings.",
    description_te:
      "తాజా రొయ్యలతో అసలైన ఆంధ్ర మసాలాలతో సుగంధభరితంగా తయారుచేయబడిన ఆవకాయ.",
    image_url: asset("products/prawn.webp"),
    category: "non-veg",
    in_stock: true,
    featured: false,
    sizes: [
      { label: "250gm", price: 350 },
      { label: "500gm", price: 700 },
      { label: "1000gm", price: 1400 },
    ],
    sort: 5,
  },
  {
    id: "p-ginger",
    slug: "ginger-pickle",
    name: "Ginger (Allam) Pickle",
    name_te: "అల్లం ఆవకాయ",
    description:
      "Classic Andhra ginger pickle with a perfect balance of spicy and tangy flavors.",
    description_te:
      "మసాలా మరియు పులుపు రుచుల సమపాళ్ళలో తయారు చేసిన క్లాసిక్ ఆంధ్ర అల్లం ఆవకాయ.",
    image_url: asset("products/ginger.webp"),
    category: "veg",
    in_stock: true,
    featured: false,
    sizes: [
      { label: "250gm", price: 125 },
      { label: "500gm", price: 250 },
      { label: "1000gm", price: 500 },
    ],
    sort: 6,
  },
  {
    id: "p-avakai",
    slug: "ulli-avakaye",
    name: "Avakaya Pickle",
    name_te: "ఆవకాయ",
    description:
      "Classic Andhra-style avakaya pickle made with raw mango, mustard powder, fenugreek seeds, garlic and pure groundnut oil.",
    description_te:
      "పచ్చి మామిడికాయలు, ఆవాల పొడి, మెంతులు, వెల్లుల్లి మరియు స్వచ్ఛమైన వేరుశెనగ నూనెతో తయారుచేయబడిన సాంప్రదాయ ఆంధ్ర ఆవకాయ.",
    image_url: null,
    category: "veg",
    in_stock: true,
    featured: true,
    sizes: [
      { label: "250gm", price: 125 },
      { label: "500gm", price: 250 },
      { label: "1000gm", price: 500 },
    ],
    sort: 7,
  },
  {
    id: "p-tomato",
    slug: "tomato-pickle",
    name: "Tomato Pickle",
    name_te: "టమాటా పచ్చడి",
    description:
      "Tangy Andhra-style tomato pickle made with ripe tomatoes and hand-ground spices.",
    description_te:
      "పండిన టమాటాలతో, చేతితో నూరిన మసాలాలతో తయారుచేయబడిన పులుపు రుచైన ఆంధ్ర టమాటా పచ్చడి.",
    image_url: null,
    category: "veg",
    in_stock: true,
    featured: false,
    sizes: [
      { label: "250gm", price: 125 },
      { label: "500gm", price: 250 },
      { label: "1000gm", price: 500 },
    ],
    sort: 8,
  },
  {
    id: "p-gongura",
    slug: "gongura-pickle",
    name: "Gongura Pickle",
    name_te: "గోంగూర పచ్చడి",
    description:
      "Tangy Andhra-style gongura (sorrel leaf) pickle, a regional favourite.",
    description_te:
      "పులుపు రుచైన గోంగూర (గోంగూర ఆకు) పచ్చడి, ఆంధ్ర ప్రాంతపు ప్రత్యేక వంటకం.",
    image_url: null,
    category: "veg",
    in_stock: true,
    featured: false,
    sizes: [
      { label: "250gm", price: 125 },
      { label: "500gm", price: 250 },
      { label: "1000gm", price: 500 },
    ],
    sort: 9,
  },
  {
    id: "p-ladoo",
    slug: "boondi-ladoo",
    name: "Boondi Ladoo",
    name_te: "బూందీ లడ్డూ",
    description:
      "Boondi Ladoo is a traditional South Asian sweet made from crispy, fried gram flour (besan) pearls. These pearls, called boondi (derived from the Hindi word boond, meaning droplet), are soaked in a warm, aromatic sugar syrup and then shaped into sweet, melt-in-the-mouth balls.",
    description_te:
      "బూందీ లడ్డూ అనేది బెసన్ పిండితో వేయించిన కరకరలాడే ముత్యాల వంటి బూందీలను వేడి పంచదార పాకంలో నానబెట్టి, సువాసన మసాలాలు కలిపి చేతులతో గుండ్రంగా తయారుచేసిన సాంప్రదాయ మధుర వంటకం.",
    image_url: asset("products/Laddus.webp"),
    category: "veg",
    in_stock: true,
    featured: false,
    sizes: [
      { label: "250gm", price: 100 },
      { label: "500gm", price: 200 },
      { label: "1000gm", price: 400 },
    ],
    sort: 10,
  },
  {
    id: "p-bellam-gavvalu",
    slug: "bellam-gavvalu",
    name: "Bellam Gavvalu",
    name_te: "బెల్లం గవ్వలు",
    description:
      "Traditional shell-shaped snack coated in a jaggery (bellam) syrup.",
    description_te:
      "బెల్లం పాకంలో నానబెట్టిన సాంప్రదాయ గవ్వల ఆకారపు స్నాక్.",
    image_url: null,
    category: "veg",
    in_stock: true,
    featured: false,
    sizes: [
      { label: "250gm", price: 100 },
      { label: "500gm", price: 200 },
      { label: "1000gm", price: 400 },
    ],
    sort: 11,
  },
  {
    id: "p-sugar-gavvalu",
    slug: "sugar-gavvalu",
    name: "Sugar Gavvalu",
    name_te: "చక్కెర గవ్వలు",
    description:
      "Traditional shell-shaped snack coated in a sweet sugar glaze.",
    description_te:
      "తీపి చక్కెర పూతతో తయారుచేసిన సాంప్రదాయ గవ్వల ఆకారపు స్నాక్.",
    image_url: null,
    category: "veg",
    in_stock: true,
    featured: false,
    sizes: [
      { label: "250gm", price: 88 },
      { label: "500gm", price: 175 },
      { label: "1000gm", price: 350 },
    ],
    sort: 12,
  },
  {
    id: "p-mixture",
    slug: "sanna-mixture",
    name: "Sanna Mixture",
    name_te: "సన్న మిక్చర్",
    description:
      "Sanna Mixture (also known as Sanna Boondi Mixture or Sanna Karapusa) is a popular savory South Indian snack celebrated for its crispy, fine texture and spicy kick. Made from ultra-thin, delicate fried gram flour pieces blended with aromatic spices — a festive favourite traditionally enjoyed during Diwali and Sankranti with a hot cup of tea or coffee.",
    description_te:
      "సన్న మిక్చర్ అనేది బెసన్ పిండితో తయారుచేసిన చాలా పలచని, కరకరలాడే ముక్కలను వేయించి సుగంధ మసాలాలు కలిపిన దక్షిణ భారత సాంప్రదాయ పిండి వంటకం. దీపావళి, సంక్రాంతి పండుగలలో సాయంకాల టీ తో ప్రత్యేకంగా ఆనందించే రుచికరమైన స్నాక్.",
    image_url: asset("products/mixture.webp"),
    category: "veg",
    in_stock: true,
    featured: false,
    sizes: [
      { label: "250gm", price: 75 },
      { label: "500gm", price: 150 },
      { label: "1000gm", price: 300 },
    ],
    sort: 13,
  },
  {
    id: "p-bondi-mixture",
    slug: "bondi-mixture",
    name: "Bondi Mixture",
    name_te: "బొందీ మిక్చర్",
    description:
      "Crispy boondi-based savory mixture blended with aromatic spices.",
    description_te:
      "కరకరలాడే బూందీతో సుగంధ మసాలాలు కలిపిన స్నాక్ మిక్చర్.",
    image_url: null,
    category: "veg",
    in_stock: true,
    featured: false,
    sizes: [
      { label: "250gm", price: 75 },
      { label: "500gm", price: 150 },
      { label: "1000gm", price: 300 },
    ],
    sort: 14,
  },
  {
    id: "p-athukula-mixture",
    slug: "athukula-mixture",
    name: "Athukula Mixture",
    name_te: "అటుకుల మిక్చర్",
    description:
      "Crispy flattened-rice (atukulu) based savory mixture blended with aromatic spices.",
    description_te:
      "కరకరలాడే అటుకులతో సుగంధ మసాలాలు కలిపిన స్నాక్ మిక్చర్.",
    image_url: null,
    category: "veg",
    in_stock: true,
    featured: false,
    sizes: [
      { label: "250gm", price: 75 },
      { label: "500gm", price: 150 },
      { label: "1000gm", price: 300 },
    ],
    sort: 15,
  },
  {
    id: "p-ribbon-jantikalu",
    slug: "ribbon-jantikalu",
    name: "Ribbon Jantikalu (Ribbon Pakoda / Ribbon Murukku)",
    name_te: "రిబ్బన్ జంతికలు",
    description:
      "Crispy ribbon-shaped savory snack, also known as ribbon pakoda or ribbon murukku.",
    description_te:
      "రిబ్బన్ ఆకారంలో తయారుచేసిన కరకరలాడే స్నాక్, రిబ్బన్ పకోడ లేదా రిబ్బన్ మురుక్కు అని కూడా పిలుస్తారు.",
    image_url: null,
    category: "veg",
    in_stock: true,
    featured: false,
    sizes: [
      { label: "250gm", price: 63 },
      { label: "500gm", price: 125 },
      { label: "1000gm", price: 250 },
    ],
    sort: 16,
  },
  {
    id: "p-jantikalu-chakralu",
    slug: "jantikalu-chakralu",
    name: "Jantikalu / Chakralu",
    name_te: "జంతికలు / చక్రాలు",
    description: "Crispy spiral-shaped rice-flour savory snack.",
    description_te:
      "బియ్యప్పిండితో తయారుచేసిన మురుక్కు ఆకారపు కరకరలాడే స్నాక్.",
    image_url: null,
    category: "veg",
    in_stock: true,
    featured: false,
    sizes: [
      { label: "250gm", price: 63 },
      { label: "500gm", price: 125 },
      { label: "1000gm", price: 250 },
    ],
    sort: 17,
  },
  {
    id: "p-chicken-podi",
    slug: "chicken-karam-podi",
    name: "Chicken Karam Podi",
    name_te: "చికెన్ కారం పొడి",
    description:
      "Andhra-style Chicken Karam Podi (also known as chicken kapuri or chicken powder) is an intensely flavorful spice blend made by deep-frying marinated boneless chicken alongside traditional aromatics and pulsing them into a coarse, spicy powder. Rich, bold, and packed with Andhra heat — perfect with steamed rice or as a side with any meal.",
    description_te:
      "బోన్‌లెస్ చికెన్‌ను మసాలాలతో వేయించి, సాంప్రదాయ ఆంధ్ర సుగంధ ద్రవ్యాలతో పాటు పొడిగా చేసిన ఆంధ్రా శైలి కారపు పొడి. అన్నంతో లేదా టిఫిన్‌తో అద్భుతంగా రుచిస్తుంది.",
    image_url: asset("products/chicken podi.webp"),
    category: "non-veg",
    in_stock: true,
    featured: false,
    sizes: [
      { label: "250gm", price: 10 },
      { label: "500gm", price: 10 },
      { label: "1000gm", price: 10 },
    ],
    sort: 18,
  },
  {
    id: "p-ulli-avakaya",
    slug: "ulli-avakaya",
    name: "Ulli Avakaya",
    name_te: "ఉల్లి ఆవకాయ",
    description:
      "Classic Andhra onion avakaya made with raw mango, baby onions, roasted gram flour and hand-ground spices.",
    description_te:
      "పచ్చి మామిడికాయలు, చిన్న ఉల్లిపాయలు, వేయించిన శనగపిండి మరియు చేతితో నూరిన మసాలాలతో తయారుచేయబడిన సాంప్రదాయ ఉల్లి ఆవకాయ.",
    image_url: asset("products/avakai.webp"),
    category: "veg",
    in_stock: true,
    featured: false,
    sizes: [
      { label: "250gm", price: 125 },
      { label: "500gm", price: 250 },
      { label: "1000gm", price: 500 },
    ],
    sort: 19,
  },
];

// Order status timeline definition
export const ORDER_STATUSES = [
  { key: "order_created", label: "Order Created", label_te: "ఆర్డర్ సృష్టించబడింది", icon: "📋", desc: "We have received your order." },
  { key: "payment_confirmed", label: "Payment Confirmed", label_te: "చెల్లింపు నిర్ధారించబడింది", icon: "💳", desc: "Payment received successfully.", optional: true },
  { key: "order_confirmed", label: "Order Confirmed", label_te: "ఆర్డర్ నిర్ధారించబడింది", icon: "✅", desc: "Your order has been accepted and added to our preparation queue." },
  { key: "under_preparation", label: "Pickles Under Preparation", label_te: "ఆవకాయ తయారవుతోంది", icon: "👨‍🍳", desc: "Fresh pickles are being prepared and packed." },
  { key: "quality_check", label: "Quality Check & Packaging", label_te: "నాణ్యత తనిఖీ & ప్యాకింగ్", icon: "📦", desc: "Your order is being inspected and securely packed." },
  { key: "ready_dispatch", label: "Ready for Dispatch", label_te: "డిస్‌పాచ్‌కు సిద్ధం", icon: "🚚", desc: "Your package is ready to be handed over to the delivery partner." },
  { key: "dispatched", label: "Order Dispatched", label_te: "ఆర్డర్ డిస్‌పాచ్ చేయబడింది", icon: "📍", desc: "Shipment has left our facility. Use the courier tracking link below to follow your package." },
  { key: "delivered", label: "Order Delivered", label_te: "ఆర్డర్ డెలివరీ అయింది", icon: "🎉", desc: "Order delivered successfully." },
];

export const CANCELLED_STATUS = {
  key: "cancelled",
  label: "Order Cancelled",
  label_te: "ఆర్డర్ రద్దు చేయబడింది",
  icon: "❌",
  desc: "This order has been cancelled.",
};

export const findStatus = (key) =>
  key === "cancelled" ? CANCELLED_STATUS : ORDER_STATUSES.find((s) => s.key === key);
export const statusIndex = (key) =>
  ORDER_STATUSES.findIndex((s) => s.key === key);
